module.exports = __webpack_public_path__ + "static/media/FitnessIcon.d1a09745.svg";